import { Controller } from "@hotwired/stimulus"

// Swaps an action form's "Set values" step between one uniform set of edit inputs
// and one editable cell per pick-table row. The value_mode radios toggle which
// group is visible, and the inactive group's fields are disabled so only the active
// mode's values post.
export default class extends Controller {
  static targets = ["perRow", "uniform"]

  select(event) {
    const perRow = event.target.value === "per_row"

    this.perRowTargets.forEach((element) => this.#toggle(element, perRow))
    this.uniformTargets.forEach((element) => this.#toggle(element, !perRow))
  }

  #toggle(element, active) {
    element.classList.toggle("hidden", !active)
    element.querySelectorAll("input, select").forEach((field) => {
      field.disabled = !active
    })
  }
}
